import { Card, CardContent, Skeleton, Stack } from '@mui/material'

export const DmRoomSkeleton = () => (
  <Card elevation={0}>
    <CardContent sx={{ py: 2, px: 4, '&:last-child': { pb: 2 } }}>
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Skeleton variant="rectangular" width={40} height={20} />
          <Skeleton variant="text" width={200} />
        </Stack>
        <Skeleton variant="text" width="80%" height={28} />
        <Stack direction="row" alignItems="flex-start" spacing={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Stack flex={1} spacing={0.5}>
            <Skeleton variant="text" width={100} />
            <Skeleton variant="text" width="90%" />
            <Skeleton variant="text" width={60} />
          </Stack>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
)
